import store from '../store'

// Any authenticated user can view the Schedule tab: business admins and
// supervisor-tradies see the full company roster board (gated further by
// the schedule.manage/schedule.view permissions inside SchedulePage.vue),
// and plain tradies see a read-only list of just their own jobs.
function requireAuthenticated(_to, _from, next) {
  const user = store.getters['auth/user']
  // A supervisor tradie with zero assigned projects is treated like a
  // non-supervisor tradie here — nothing on this tab would render for them
  // anyway (see isActiveSupervisorTradie).
  const isActiveSupervisorTradie =
    store.getters['auth/isActiveSupervisorTradie']
  if (
    !user ||
    (user.user_type !== 'business_admin' && !isActiveSupervisorTradie)
  ) {
    return next({ name: 'home.welcome-page' })
  }
  next()
}

export default {
  path: '/schedule',
  name: 'schedule.index',
  redirect: { name: 'schedule.list-page' },
  component: () =>
    import(/* webpackChunkName: "schedule" */ '@/views/schedule/index.vue'),
  beforeEnter: requireAuthenticated,
  children: [
    {
      path: '/schedule',
      name: 'schedule.list-page',
      component: () => import('@/views/schedule/SchedulePage.vue'),
    },
  ],
}
